import {
	ConfluenceTemplatesUnifiedRelayPageTemplate,
	ConfluenceTemplatesUnifiedRelayPageTemplateProps,
} from '@/templates/software/confluence/templates/confluence-templates-page/src/relay/contentful-relay/confluence-templates-unified-contentful-relay-page.template';

export type ConfluenceTemplateCategoryRelayPageProps =
	ConfluenceTemplatesUnifiedRelayPageTemplateProps;

export const ConfluenceTemplateCategoryRelayPage = ({
	queryRef,
}: ConfluenceTemplateCategoryRelayPageProps) => {
	return <ConfluenceTemplatesUnifiedRelayPageTemplate queryRef={queryRef} />;
};
